/** The stored sizes of an itinerary's cover: 150px square, about 300px, and about 1024px. */
export type CoverImageSize = "tiny" | "medium" | "large";

interface CoverImageSource {
  url: string;
  width?: number;
  height?: number;
}

// The server's shape for the sizes; @eventr/common's IEventrGeneralInfo does not carry them yet.
export interface CoverImageInfo {
  cover_image?: string;
  cover_image_sizes?: Partial<Record<CoverImageSize, CoverImageSource>>;
}

// Each size, then the larger ones that can stand in for it. The tiny size is cropped square, so
// it never stands in for a larger one.
const STAND_INS: Record<CoverImageSize, readonly CoverImageSize[]> = {
  tiny: ["tiny", "medium", "large"],
  medium: ["medium", "large"],
  large: ["large"],
};

/** The cover at `size`, or the nearest larger size stored, or the original upload. */
export function coverImageUrl(info: CoverImageInfo | undefined | null, size: CoverImageSize): string | undefined {
  const sizes = info?.cover_image_sizes;
  const stored = STAND_INS[size].map((key) => sizes?.[key]?.url).find(Boolean);
  // An empty string is "no cover image" in the itinerary payload.
  return stored || info?.cover_image || undefined;
}
